import { TTintServiceState } from '../types/tint-service-state.type';

export const getColoringName = (selectedColor: TTintServiceState['selectedColor']) => {
  if (!selectedColor) {
    return '-';
  }

  return selectedColor.COLLECTION_NAME
    ? `${selectedColor.COLLECTION_NAME} ${selectedColor.COLOR_NAME}`
    : `${selectedColor.COLOR_NAME}`;
};
